<template>
  <DropDown class="w-full" v-model="filterToggle">
    <template #action>
      <Button cockpit outlined block>
        <Flex justify-between items-center gap-3>
          <i class="fa-solid fa-filter" />
          <span>Filtrar</span>
          <div class="bg-cockpit-green text-xs font-bold size-4 rounded-full text-cockpit-canvas mr-2" v-if="activeFiltersCount > 0">
            {{ activeFiltersCount }}
          </div>
          <ChevronY v-model="filterToggle" />
        </Flex>
      </Button>
    </template>
    <template #default>
      <Grid gap-3 :class="[filters.length >= 5 ? 'grid-cols-2 w-[720px]' : 'grid-cols-1 w-[560px]', 'grid gap-5']">
        <div v-for="(item, i) in filters" :key="i" class="w-full col-span-1">
          <!--  Inputs Comuns -->
          <InputText
            v-if="item.type == 'text'"
            v-model="object[item.param]"
            :label="item.label"
            :placeholder="item.placeholder ? item.placeholder : `Digite ${item.label.toLowerCase()}`" />
          <InputNumber
            v-if="item.type == 'number'"
            type="number"
            v-model="object[item.param]"
            :label="item.label"
            :placeholder="item.placeholder ? item.placeholder : `Digite ${item.label.toLowerCase()}`" />
          <Select
            v-if="item.type == 'select'"
            :items="item.items"
            v-model="object[item.param]"
            :label="item.label"
            :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`"
            clearable />
          <InputDate
            v-if="item.type == 'date'"
            v-model="object[item.param]"
            :label="item.label"
            :placeholder="item.placeholder ? item.placeholder : `Digite ${item.label.toLowerCase()}`"
            clearable />
          <InputDateRange
            v-if="item.type == 'range'"
            v-model="object[item.param]"
            :label="item.label"
            :placeholder="item.placeholder ? item.placeholder : `Digite ${item.label.toLowerCase()}`"
            clearable />

          <InputZoom
            v-if="item.type == 'zoom'"
            v-model="object[item.param]"
            :label="item.label"
            :database="item.database"
            :item-text="item.itemText"
            :item-value="item.itemValue"
            :item-autocomplete="item.itemAutocomplete"
            :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`"
            clearable />

          <InputZoomMultiple
            v-if="item.type == 'zoomMultiple'"
            v-model="object[item.param]"
            :label="item.label"
            :database="item.database"
            :item-text="item.itemText"
            :item-value="item.itemValue"
            :table-filter="item.tableFilter"
            :item-autocomplete="item.itemAutocomplete"
            :placeholder="item.placeholder ? item.placeholder : `Selecione ${item.label.toLowerCase()}`"
            clearable />
        </div>
      </Grid>
      <Line />
      <Flex justify-end gap-2 class="py-3">
        <Button cockpit label="Buscar" icon="fa-solid fa-magnifying-glass" @click="emitConfirm" />
        <Button cockpit outlined label="Limpar" icon="fa-solid fa-xmark" @click="clear" />
      </Flex>
    </template>
  </DropDown>
</template>

<script setup>
// Imports
import { ref, reactive, computed } from 'vue'
// Props
const props = defineProps({
  filters: Array,
  modelValue: Object,
})
// Emits
const emits = defineEmits(['update:modelValue'])
// Data
let filterToggle = ref(false)
let object = reactive({ ...props.modelValue })

// Computed
const activeFiltersCount = computed(() => {
  if (Array.isArray(props.modelValue)) {
    return props.modelValue.length
  }
  return 0
})

// Methods
const emitConfirm = () => {
  filterToggle.value = false
  const params = []
  for (const filter of props.filters) {
    if (object[filter.param]) {
      params.push({
        column: filter.param,
        operator: filter?.operator,
        value: object[filter.param],
      })
    }
  }
  emits('update:modelValue', params)
}
const clear = () => {
  Object.keys(object).forEach((key) => delete object[key])
  emits('update:modelValue', {})
  filterToggle.value = false
}
</script>
